import { useAction } from "@/hooks/shared";
import { getExamStatusHandler } from "@/services";

export const useExamStatus = () => useAction(getExamStatusHandler);
